import React, { useEffect } from "react";
 
const ShopCard = (props) => {
  // useEffect(() => {
  //   props.setSubcategories();
  // }, []);
 
  return ( 
    <React.Fragment>
      <div className="col-sm-3 mt-2">
        <div
          className="card"
          style={{ border: "2px solid rgba(0,0,0,.125)", maxWidth: "230px" }}
        >
          <div className="card-body">
            <h5 className="card-title mt-2">{props.subCategoryName}</h5>
            <button
              href="#"
              className="btn btn-warning btn-sm m-0 p-0 px-2 mr-2"
              data-toggle="modal"
              data-target={`#che${props.id}`}
              // style={{ backgroundColor: "blue" }} 
              onClick={()=>props.setSubcategories()}
            >
              Edit
            </button>
            {/* ------------------------------------ Edit Brand Modal starts ------------------------------------*/}
            <div
              className="modal fade"
              id={`che${props.id}`}
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Edit and Save the details
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <form>
                      <div className="form-group">
                        <label
                          htmlFor="subCategoryName"
                          className="col-form-label"
                        >
                          Name:
                        </label>
                        <input
                          name="editShopName"
                          type="text"
                          className="form-control"
                          id="editShopName"
                          value={props.editShopName}
                          onChange={(e) =>
                            props.handleChange(
                              e,
                              props.id,
                              props.subCategoryName
                            )
                          }
                        />
                      </div>
                    </form>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-primary btn-sm"
                      style={{ backgroundColor: "green" }}
                      onClick={(e) => {
                        e.preventDefault()
                        props.handleEditSubmit(e, props.id)
                      }}
                      disabled={props.shopBtnLoading}
                    >
                      {props.shopBtnLoading ? "Saving" : "Save"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* ------------------------------------ Edit Brand Modal ends ------------------------------------*/}
            <button
              href="#"
              className="btn btn-secondary m-0 p-0 px-2 btn-sm"
              style={{ backgroundColor: "red" }}
              data-toggle="modal"
              data-target={`#chd${props.id}`}
            >
              Delete
            </button>
            {/* ------------------------------------ Delete Brand Modal starts ------------------------------------*/}
            <div
              className="modal fade"
              id={`chd${props.id}`}
              tabIndex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                      Irreversible Operation
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      id={`closeshopmodal${props.id}`}
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <p>
                      Are you sure you want to delete {props.subCategoryName}?
                    </p>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary btn-sm"
                      style={{ backgroundColor: "red" }}
                      onClick={(e) =>
                        props.handleDeleteSubCategories(e, {
                          id: props.id,
                        })
                      }
                      disabled={props.deleteBtnLoading}
                    >
                      {props.deleteBtnLoading ? "Deleting" : "Delete"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* ------------------------------------ Delete Brand Modal ends ------------------------------------*/}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ShopCard;
